<template>
<div role="group" class="b-form-group form-group">
  <loading v-if="isLoading"></loading>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="name">
          <b-form-input type="text" v-model="formData.name"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('SELECTFILE')">
        <fileupload v-model="formData.file" :chooseLabel="$t('SELECTFILE')" />
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
    name: 'TherapyTypeForm',
    props: ['formData', 'formError', 'isLoading'],
};
</script>
